import { useCallback, useEffect, useMemo } from "react";
import { useNavigate } from "react-router-dom";

import PrimaryButton from "../../Components/Buttons/primary-button";

import renderCreditBuilderLearnMore from "../../Organisms/Modals/Credit-Builder/learn-more";
import renderCreditBuilderOptIn from "../../Organisms/Modals/Credit-Builder/credit-builder-opt-in";
import renderCreditBuilderOptOut from "../../Organisms/Modals/Credit-Builder/credit-builder-opt-out";

import useStakeCheckingStatusAction from "../../CustomHooks/useStakeCheckingStatusAction";

import { useCreditReportDetails, useStakeDebit } from "../../CustomHooks/Queries";

import { useModalContext } from "../../Contexts/ModalContext";

import { isSVDApproved, isSVDEligible } from "../../Utils/helpers";

import { CreditBuilderCoin, CreditBuilderSparkle } from "../../Assets/Images";

export default function OptCreditBuilder({ useAsNavigationCard = false }) {
  const navigate = useNavigate();
  const modalContext = useModalContext();

  const { data: creditReporting } = useCreditReportDetails();
  const { data: stakeDebit } = useStakeDebit();

  const isCreditReportingOptedIn = useMemo(() => {
    return creditReporting?.data?.data.credit_builder?.opted_in;
  }, [creditReporting?.data?.data.credit_builder?.opted_in]);

  const IsSVDApproved = useMemo(() => isSVDApproved(stakeDebit?.data), [stakeDebit?.data]);

  const stakeCheckingStatusAction = useStakeCheckingStatusAction();

  const handleOpenCreditBuilder = useCallback(() => {
    if (!IsSVDApproved) {
      if (isSVDEligible(stakeDebit?.data)) {
        navigate("/apply-stake-checking");
      } else {
        stakeCheckingStatusAction(stakeDebit?.data);
      }
    } else if (useAsNavigationCard) {
      navigate("/credit-builder");
    } else if (isCreditReportingOptedIn) {
      renderCreditBuilderOptOut(modalContext);
    } else {
      renderCreditBuilderOptIn(modalContext);
    }
  }, [
    navigate,
    modalContext,
    IsSVDApproved,
    isCreditReportingOptedIn,
    useAsNavigationCard,
    stakeDebit?.data,
    stakeCheckingStatusAction,
  ]);

  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);

    if (searchParams.get("openCreditBuilder") === "true") {
      handleOpenCreditBuilder();
      window.history.replaceState({}, "", window.location.pathname);
    }
  }, [handleOpenCreditBuilder]);
  return (
    <div className="credit-builder-setting">
      <img className="coin" src={CreditBuilderCoin} alt=""></img>
      <img className="sparkle" src={CreditBuilderSparkle} alt=""></img>
      <div className="section-header mb-sm-6 mb-4">
        <div className="section-content">
          <div className="section-title">Credit Builder</div>
          <div className="section-description">
            Stake only reports on-time rent payments that help build your credit.{" "}
            <button className="color--primary-400" onClick={renderCreditBuilderLearnMore.bind(this, modalContext)}>
              Learn more.
            </button>
          </div>
        </div>
      </div>
      <PrimaryButton onClick={handleOpenCreditBuilder}>
        {!IsSVDApproved
          ? "Open Stake Account"
          : useAsNavigationCard
            ? "View"
            : isCreditReportingOptedIn
              ? "Edit my preferences"
              : "Start"}
      </PrimaryButton>
    </div>
  );
}
